import React from "react"
import PropTypes from "prop-types"

import { federalRegions } from "shared/imports/regionConstants"

import { searchifySelectGenericFilter, toggleGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    PublicOrganizationFilterableListView,
    RegulationFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import { PublicOrganizationSelect, RegulationSelect } from "app/static/frontend/selects/containers/PieSelect"

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    helpText: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    placeholderText: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}

export const AgencyPublicOrganizationFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PublicOrganizationFilterableListView} {...props} />
}
AgencyPublicOrganizationFilter.propTypes = defaultPropTypes
AgencyPublicOrganizationFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "agencyPublicOrganizationFilter",
    filterKey: "associated_with_public_organization",
    dataTypeLabel: "Public Organizations",
    displayLabel: "Public Organizations",
    selectComponent: PublicOrganizationSelect,
}

export const AgencyRegulationFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={RegulationFilterableListView} {...props} />
}
AgencyRegulationFilter.propTypes = defaultPropTypes
AgencyRegulationFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "agencyRegulationFilter",
    filterKey: "associated_with_regulation",
    dataTypeLabel: "Regulations",
    displayLabel: "Regulations",
    selectComponent: RegulationSelect,
}

export const AgencyFederalRegionFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
AgencyFederalRegionFilter.propTypes = defaultPropTypes
AgencyFederalRegionFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "agencyFederalRegionFilter",
    filterKey: "is_federal_region",
    displayLabel: "Is Federal",
    trueText: "Yes",
    falseText: "No",
    regions: federalRegions,
}
